<template>
  <div class="lista-tiendas-mobile">
    <TiendaCard
      v-for="(tienda, i) in tiendas"
      :key="`tienda_${i}`"
      :tienda="tienda"
    />
  </div>
</template>
<script>
import TiendaCard from '../cards/TiendaCard.vue'

export default {
  name: 'ListaTiendasMobile',
  components: { TiendaCard },
  props: {
    tiendas: {
      type: Array
    }
  },
  mounted () {
    this.$vuetify.goTo(0)
  }
}
</script>

<style scoped>
.lista-tiendas-mobile {
  max-width: 520px;
  margin: 0 auto;
}
</style>
